// HTTP status codes
export const CREATED = 201
export const NOT_FOUND = 404
export const OK = 200
// make sure the FABRICS and LININGS values are equal to their state modules
export const FABRICS = "fabrics"
export const LININGS = "linings"
// article types
export const CURTAIN = "curtain"
export const RAIL_ROD = "railRod"
// required parameters for curtain price calculation or curtain order,
// depending on the curtain type
export const REQUIRED_CURTAIN_PARAMETERS = {
  'pleatcurtain': [
    'main_fabric',
    'height',
    'width',
    'split_type',
    'hem_type',
    'luxury',
    'pleat_type'
  ],
  'wavecurtain':[
    'main_fabric',
    'height',
    'width',
    'split_type'
  ],
  'ringcurtain': [
    'main_fabric',
    'height',
    'width',
    'split_type',
    'luxury',
    'ring_size',
    'ring_type'
  ]
}
// rail types
export const TRACK_RAIL = 'trackrail'
export const DECORATIVE_RAIL = 'decorativerail'
// rod types
export const DECORATIVE_ROD = 'decorativerod'
export const SPOTLIGHT_ROD = 'spotlightrod'
// required parameters for rail rod price calculation or rail rod order,
// depending on the rail rod type
export const REQUIRED_RAIL_ROD_PARAMETERS = {
  [TRACK_RAIL]: [
    'color',
    'support_type',
    'width'
  ],
  [DECORATIVE_RAIL]: [
    'color',
    'rail_type',
    'support_type',
    'runner_color'
  ],
  [DECORATIVE_ROD]: [
    'color',
    'rod_size',
    'support_type'
  ],
  [SPOTLIGHT_ROD]: [
    'color',
    'width'
  ],
}
// the array of curtain types that are allowed to get a rail or rod
export const RAIL_ROD_CURTAIN_TYPES = [
  'pleatcurtain',
  'wavecurtain',
  'fronslintcurtain',
  'ringcurtain'
]
export const CURTAIN_TYPES_WITH_RAILS = [
  'pleatcurtain',
  'wavecurtain'
]
// the array of all rail rod types that are available
export const RAIL_ROD_TYPES = [
  TRACK_RAIL,
  DECORATIVE_RAIL,
  DECORATIVE_ROD
]
// the array of all rail types that are available
export const RAIL_TYPES = [
  TRACK_RAIL,
  DECORATIVE_RAIL
]

export const FLOW_MAP_TABLE = {
  splitTypeStep: ['split_type'],
  grommetColorStep: ['ring_type'],
  rodColorStep: ['color'],
  trackColorStep: ['color'],
  supportTypeStep: ['support_type'],
}

export const PRODUCT_DEFAULTS = {
  'pleatcurtain': {
    'pleat_type': 'double',
    'luxury': 'basic',
    "hem_type": "double",
    "pleat_percentage": 220,
  },
  'ringcurtain': {
    'ring_size': 'ringsize30mm',
    'luxury': 'basic',
    "hem_type": "double",
    "pleat_percentage": 250,
  }
}
